'use client'

import dynamic from 'next/dynamic'

const CookieBanner = dynamic(async () => import('./CookieBanner'), { ssr: false })

export default function () {
  return <CookieBanner />
}
